type Currency = {
    id: string
    symbol: string
}

const currencies: Currency[] = [
    {
        id: "EUR",
        symbol: "€",
    },
    {
        id: "CHF",
        symbol: "CHF",
    },
    {
        id: "GBP",
        symbol: "£",
    },
]

export { currencies }
